module.exports = __webpack_public_path__ + "static/media/statueOfLiberty.8836a831.jpg";